// FIXME: переместить в utils/storage

export const lastSelectedCompanyKey = 'last-selected-company';
export const lastSelectedRoleKey = 'last-selected-role';

export function getLastSessionSelectedCompany() {
  const value = window?.localStorage.getItem(lastSelectedCompanyKey);
  if (value) {
    try {
      return JSON.parse(value);
    }
    catch (e) {
      if (e instanceof SyntaxError) {
        return null;
      }

      throw e;
    }
  }

  return null;
}

export function setLastSessionSelectedCompany(data) {
  window?.localStorage.setItem(lastSelectedCompanyKey, JSON.stringify(data));
}

export function getLastSelectedRole() {
  window?.localStorage.getItem(lastSelectedRoleKey);
}

export function setLastSelectedRole(role) {
  window?.localStorage.setItem(lastSelectedRoleKey, role);
}

export const removeLastSessionSelectedCompany = () => window?.localStorage.removeItem(lastSelectedCompanyKey);
